export const locale = {
    lang: 'en',
    data: {
        'Headers': {
            'MaterialPrice': 'Material Price',
            'OfferPrice': 'Offer Price',
            'SuppliersItemPriceChangeList': 'Suppliers material price change list'
        },
        "FIELDS": {
            'Supplier': 'Supplier',
            'Percentage': 'Percentage',
            'RetailPrice': 'Retail Price',
            'SalesPrice': 'Sales Price',
            'PurchasePrice': 'Purchase price',
            'PersonalPrice': 'Personal Price',
            'OfferPrice': 'Offer Price',

            'SRNO': 'Sr nr.',
            "Edit": 'Edit',
            "Delete": 'Delete',
            "ChangedBy": 'Changed By'
        },
        "BUTTONS": {
            'BTNSAVE': 'Save',
            'BACK': 'Back',
        },
        "MESSAGES": {
            'Added': 'Added Successfully',
            'Updated': 'Updated Successfully.',
            'Failed': 'Failed',
            'Deleted': 'Deleted successfully',
            "NORECORD": "No Record Found"
        },
        "VALIDATIONS": {
            'SupplierRequired': 'Select Supplier',
            'PercentageRequired': 'Enter Percentage'
        }
    }
}